import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { FoodModel, MealModel } from '../../models/models';
import { ConfigurationProvider, FoodProvider, MealProvider } from '../../providers/providers';

@Component({
  selector: 'page-meal-edit',
  templateUrl: 'meal-edit.html',
})
export class MealEditPage {
  deleteFoodItems: number[] = [];
  foodList: FoodModel[] = [];
  foodListSearch: FoodModel[] = [];
  item: MealModel;

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private foodProvider: FoodProvider,
    private mealProvider: MealProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      name: item ? item.Name : null
    });
  }

  doGetItems(ev: any) {
    // Reset items back to all of the items
    this.foodListSearch = [];
    
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.foodListSearch = this.foodList.filter((item) => {
        return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  doRemove(item: any) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            if (item._id) {
              this.deleteFoodItems.push(item._id);
            }
            this.item.FoodItems = this.item.FoodItems.filter((m: FoodModel) => m !== item);
          }
        }
      ]
    });
    confirm.present();
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // delete food items, if any
      if (this.deleteFoodItems.length > 0) {
        this.mealProvider.DeleteFoodItems(this.deleteFoodItems);
      }

      // save meal item
      this.mealProvider.Save(this.item).then((res: MealModel) => {

        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res);
      });
    }
  }

  doSelectFood(item: any) {
    const prompt = this.alertCtrl.create({
      title: 'Log Food',
      message: item.Name,
      inputs: [
        {
          name: 'serving',
          type: 'serving',
          placeholder: 'Servings',
          value: '1'
        },
      ],
      buttons: [
        {
          text: 'Cancel'
        },
        {
          text: 'Add',
          handler: data => {
            item.Serving = data.serving;
            if (this.item.FoodItems === undefined) {
              this.item.FoodItems = [] as FoodModel[];
            }
            if (this.item.FoodItems.find((x: FoodModel) => {
              return x === item;
            }) === undefined) {
              item.FoodId = item._id;
              item._id = null;
              this.item.FoodItems.push(item);
            }
          }
        }
      ]
    });
    prompt.present();
  }

  formIsValid() {
    if (!this.item.Name) {
      this.config.showAlert('Error', 'Must enter a Name.');
      return false;
    }
    else if (this.item.FoodItems.length === 0) {
      this.config.showAlert('Error', 'Must search for and select at least one food item.');
      return false;
    }

    // check if item exists
    if (this.mealProvider.Exists(this.item)) {
      this.config.showAlert('Error', 'Meal with this name and ingredients already exists!');
      return false;
    }

    return true;
  }

  ionViewWillLoad() {
    this.item = this.params.get('item');
    this.item.FoodItems.map((x: any) => {
      x.showDetails = false;
      x.icon = 'arrow-dropright';  
    });
    this.loadFoodItems();
  }

  loadFoodItems() {
    this.foodProvider.Load().then((items: FoodModel[]) => {
      items.map(x => x.Serving = 1);
      this.foodList = items;
    });
  }

  toggleDetails(item) {
    if (item.showDetails) {
      item.showDetails = false;
      item.icon = 'arrow-dropright';
    }
    else {
      item.showDetails = true;
      item.icon = 'arrow-dropdown';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/meal-edit.ts